import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {Routes} from "../ContainerPage";
import {BottomWrapper, CoreWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import H2 from "../../Components/H2";

import {sendValidatePhone, toggleIdentificationMode} from "./Actions";
import {
    CenterContainer, FlexContainer,
    TextContainer,
    VerticalSpace
} from "./CommonUI";

import {Checkbox} from 'rmwc/Checkbox';
import {getSafely} from "@tomeravni/easybizy-js-common/common";
import SwitchButton from "../../Components/SwitchButton";
import Carousel from "../../Components/Slider";
import P from "../../Components/P";
import SingleLineInput from "../../Components/SingleLineInput";
import {validateAdaptEmail, validateAdaptPhoneNumber} from "../../Common/validation";

const CheckBoxWrapper = styled.div`
    visibility: ${p => p.visible ? 'visible' : 'hidden'};
    opacity: ${p => p.visible ? 1 : 0};
    transform: ${p => p.visible ? 'none' : 'translateX(50%)'};
    transition: all 300ms ease-in;

    a {
        color: ${p => p.theme.colors.primaryText};
    }

    label {
        color: ${p => p.theme.colors.primaryText};
    }
`;

class Identify extends ContainerPage {
    state = {
        agreeToTerms: false,
        showAgreeToTerms: false,
        index: 0
    };

    constructor(props) {
        super(props);
        this.allowAnonymous = true;
        this.nextRoute = Routes.validate;
    }

    didNavigate = false;

    componentDidUpdate(prevProps) {
        if (
            !this.didNavigate &&
            this.props.config?.Customer &&
            prevProps.config?.Customer !== this.props.config.Customer
        ) {
            this.didNavigate = true;
            this.startOver();
        }
    }

    sendValidationCode(value) {
        if (!this.state.agreeToTerms) {
            return this.showToastMessage(this.props.intl.formatMessage({id: 'app.mustAgreeToTermsAndPrivacy'}));
        }

        const medium = Object.assign({}, value);
        if (medium.phone) {
            medium.mobile = medium.phone.replace(/-/gi, '');
            delete medium.phone;
        }

        this.props.validate(medium, this.props.config.Token, (err) => {
            if (!err) {
                this.showToastMessage(this.props.intl.formatMessage({id: 'app.weSentYouApprovalCode'}));
                setTimeout(() => {
                    this.next();
                }, 1000);
            }
        });
    }

    buttonWrapperClicked(isValid) {
        if (!isValid) {
            this.showToastMessage(this.props.intl.formatMessage({id: 'invalid_phone_number'}));
        } else if (!this.state.agreeToTerms) {
            this.showToastMessage(this.props.intl.formatMessage({id: 'app.mustAgreeToTermsAndPrivacy'}));
        }
    }

    toggleIdentificationMode(forceType) {
        let typeToSet = forceType;
        if (!forceType) {
            typeToSet = this.props.isPhoneIdentified ? 'email' : 'phone';
        }

        this.props.toggleIdentificationMode(typeToSet);
    }

    updateShowAgreeToTerms(isValid) {
        this.safeSetState({showAgreeToTerms: isValid});
    }

    render() {
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';
        const phoneLabel = this.props.intl.formatMessage({id: 'schedule.phoneNumber'})
        const emailLabel = this.props.intl.formatMessage({id: 'input_email'})
        const currentIndex = this.props.isPhoneIdentified ? 0 : 1;
        const allowEmailAuth = getSafely(['props', 'config', 'EnableEmailAuthentication'], this);

        return (
            <div className="transition-item detail-page detail-page__identify">
                <CoreWrapper padding={true}
                             loading={!this.props.config || this.props.sendingValidationCode}
                             ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr}
                                     rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={0} visible={true}/>
                    </ToolbarWithLogo>

                    <TopWrapper justify="start" align="start">
                        <CenterContainer>
                            <H2 center={true}><FormattedMessage id="schedule.identifyHeader"/></H2>
                            <H1><FormattedMessage id="schedule.letsMeet"/></H1>
                        </CenterContainer>
                        <TextContainer>
                            {allowEmailAuth && <FlexContainer>
                                <P className="cursor-pointer"
                                   onClick={this.toggleIdentificationMode.bind(this, 'phone')}><FormattedMessage
                                    id="phone_identification"/></P>
                                <SwitchButton onChange={this.toggleIdentificationMode.bind(this)}
                                              active={this.props.isPhoneIdentified}/>
                                <P className="cursor-pointer"
                                   onClick={this.toggleIdentificationMode.bind(this, 'email')}><FormattedMessage
                                    id="email_identification"/></P>
                            </FlexContainer>}
                            <VerticalSpace/>
                            <Carousel currentIndex={currentIndex}>
                                <SingleLineInput inProgress={this.props.sendingValidationCode}
                                                 label={phoneLabel}
                                                 inputType="tel"
                                                 autoComplete="tel"
                                                 onSubmit={(val) => this.sendValidationCode({phone: val})}
                                                 wrapperOnClick={this.buttonWrapperClicked.bind(this)}
                                                 validateAdaptValue={validateAdaptPhoneNumber}
                                                 validityStatusChange={this.updateShowAgreeToTerms.bind(this)}
                                                 isFocused={this.props.isPhoneIdentified}
                                />

                                <SingleLineInput inProgress={this.props.sendingValidationCode}
                                                 onSubmit={(val) => this.sendValidationCode({email: val})}
                                                 label={emailLabel}
                                                 inputType="email"
                                                 autoComplete="email"
                                                 inputFont={'large'}
                                                 wrapperOnClick={this.buttonWrapperClicked.bind(this)}
                                                 validateAdaptValue={validateAdaptEmail(true)}
                                                 validityStatusChange={this.updateShowAgreeToTerms.bind(this)}
                                                 isFocused={!this.props.isPhoneIdentified}
                                />
                            </Carousel>
                            {this.state.didMount && <CheckBoxWrapper visible={this.state.showAgreeToTerms}>
                                <Checkbox
                                    checked={this.state.agreeToTerms}
                                    onChange={evt => this.setState({agreeToTerms: evt.target.checked})}>
								<span><FormattedMessage id="app.agreeToTerms"/><a target="_blank"
                                                                                  rel="noopener noreferrer"
                                                                                  href="https://easybizy.net/privacy_customer"><FormattedMessage
                                    id="app.privacy"/></a>&nbsp;
                                    <span><FormattedMessage id="app.and"/><a target="_blank"
                                                                             rel="noopener noreferrer"
                                                                             href="https://easybizy.net/customer_terms"><FormattedMessage
                                        id="app.terms"/></a>.</span></span>
                                </Checkbox>
                            </CheckBoxWrapper>}
                        </TextContainer>
                        <BottomWrapper empty={true}>
                            <PoweredBy/>
                        </BottomWrapper>
                    </TopWrapper>

                </CoreWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig,
        config: state.schedule.config,
        progress: state.schedule.progress,
        sendingValidationCode: state.identify.sendingValidationCode,
        validationHash: state.identify.validationHashResponse,
        isPhoneIdentified: state.identify.identificationMode === 'phone',
    };
};

const mapDispatchToProps = dispatch => {
    return {
        validate: (medium, token, callback) => dispatch(sendValidatePhone(medium, token, callback)),
        toggleIdentificationMode: (mode) => dispatch(toggleIdentificationMode(mode)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Identify));
